import React, {useEffect} from 'react';
import './App.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import routesArr from "./routes";
import MainLayout from '../src/layout/MainLayout'
import {googleTagManager} from "./utils/googleTagManager";

export default function App() {
    useEffect(()=> {
        googleTagManager("GTM-MN5D67");
    },[]);
    return (
        <BrowserRouter basename="/sc">
            <Routes>
                <Route  element={<MainLayout />}>
                    {routesArr.map((route, index) => (
                        <Route caseSensitive key={index} index={route.index} path={route.path} element={route.element} />
                    ))}
                </Route>
            </Routes>
        </BrowserRouter>
    );
}